// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json` file.

export const environment = {
  production: true,
  hmr: false,
  /** True only when the browser loads SSR HTML (production deploy). Off for `ng serve`. */
  enableClientHydration: false,
  // path: 'https://api.falaya.com/api',
  path: 'https://devapi.falaya.com/api',
  offer_download_lambda_path:
    'https://2iqhyfvns8.execute-api.us-east-2.amazonaws.com/initial_deploy/downloadofferpdf',
  // offer_download_lambda_path: 'https://2iqhyfvns8.execute-api.us-east-2.amazonaws.com/initial_deploy/downloadofferpdf',
  //  path: 'http://unlockd-api.us-east-2.elasticbeanstalk.com/api',
  //  cms_path: 'http://3.133.96.20',
  cms_path: 'https://cms.falaya.com',
  //  path: 'http://localhost:8083/api',
  staticPath: 'http://localhost:4200/',
  appPath1: 'http://dev.falaya.com',
  api_version: '1',
  buyerModule: true,
  ga_tracking_id: 'UA-158811500-1',
  helloSign: {
    clientId: '4ca1f001a4d0a01ffa6395188b4ed8a7',
    testMode: true,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.